module.exports = __webpack_public_path__ + "img/P15a_130516_Cup_Arrival.01ca55a8.jpg";